//firebase.js

// import firebase from 'firebase/app'
// import 'firebase/firebase-messaging'


var result = {};
try {
   const firebase = require('firebase/app').default; 
    require ('firebase/firebase-messaging').default;
    var firebaseConfig = {
        apiKey: "AIzaSyAPl3zX8Voo8hWtNa50gXaV1jhVlklaWjA",
        authDomain: "sportportal-62fb2.firebaseapp.com",
        databaseURL: "https://sportportal-62fb2.firebaseio.com",
        projectId: "sportportal-62fb2",
        storageBucket: "sportportal-62fb2.appspot.com",
        messagingSenderId: "657889925335",
        appId: "1:657889925335:web:fe897140731a427694b892"
    }
    
    firebase.initializeApp(firebaseConfig)
    
  result = firebase?.messaging?.()

} catch (error) {
    console.log(1,error)
}


export default result;
